import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * useNotificationsTabPanelStyles defines the styles for the NotificationsTabPanel component.
 */
const useNotificationsPageStyles = makeStyles()(() => ({
  noNotifications: {
    color: colors.gray[400],
    fontStyle: 'italic',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: theme.containerShadow,
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.h6,
    margin: theme.margin.m,
    borderRadius: theme.borderRadius.s,
    padding: theme.padding.m,
    backgroundColor: theme.background.paper,
  },
}));

export default useNotificationsPageStyles;
